import type { CommentConfig } from 'component/comment';
import { CommentsInput } from 'component/comment';
import type { QuestionConfig } from 'structure/question';
import type { Feature } from 'util/stdtypes';

export const MultiAnswerFeature: Feature<QuestionConfig, CommentConfig> = {
    key: 'multi-answer',
    name: 'Multi Answer',
    dev: true,
    providesConfig: {
        composerPreview: CommentsInput,
        commentAllowMultiple: true,
    },
};
